module.exports = __webpack_public_path__ + "img/photo3_9.b0b36c6f.jpg";